var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support-club"},[_c('div',{staticClass:"page-container"},[_c('PageTitle',{attrs:{"ch":"偶迷俱樂部","en":"Membership"}}),_vm._v(" "),_c('BannerSplit2SupportClub'),_vm._v(" "),_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSebsEdhnSjT9JiKPJCcXBol4UzL2984e4GR_1ovlBJatKnDQw/viewform","frameborder":"0"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc641d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/support/support_team.vue
// module id = null
// module chunks = 